const it = {
  home: {
    biometric_label: "VERIFICA DELL'IDENTITÀ BIOMETRICA",
    title: "Ricerca Inversa di Volti",
    description:
      "Carica un ritratto ad alta risoluzione per incrociare i riferimenti con gli archivi digitali globali tramite corrispondenza neurale avanzata.",
    drag_drop: "Trascina e rilascia la tua immagine",
    file_formats: "Supporta RAW, JPEG o PNG (Max 15MB)",
    select_file: "SELEZIONA FILE DAL SISTEMA",
    initiate_scan: "Avvia Scansione Forense",
    upload_hint: "CARICA UN'IMMAGINE PER CONTINUARE",
    uploading: "Caricamento",
    searching: "Scansione",
    result_title: "Risultati",
    drop_here: "Rilascia l'immagine qui...",
    billion_faces: "Confronta con oltre 1 miliardo di volti su internet",
    login_to_search: "Accedi per cercare",
    login_required: "Accedi o crea un account per utilizzare questa app",
    not_enough_tokens: "Token insufficienti",
    please_wait: "Attendi qualche minuto",
    leave_confirmation: "C'è un processo in corso. Sei sicuro di voler uscire?",
  },
  sources: {
    section_title: "Fonti Consultate",
    social_media: {
      name: "Social Media",
      description:
        "Riferimenti incrociati sui principali social network e profili pubblici.",
    },
    web: {
      name: "Web",
      description:
        "Scansiona il web aperto per dati di volti disponibili pubblicamente.",
    },
    scammers: {
      name: "Truffatori",
      description: "Confronta con database di identità di truffatori noti.",
    },
    sexual_offenders: {
      name: "Molestatori Sessuali",
      description:
        "Riferimenti incrociati con i registri pubblici dei trasgressori registrati.",
    },
    videos: {
      name: "Video",
      description: "Estrae e confronta volti da piattaforme video pubbliche.",
    },
    police_photos: {
      name: "Foto Poliziali",
      description:
        "Confronta con database di registri poliziali disponibili pubblicamente.",
    },
    news_and_blogs: {
      name: "Notizie e Blog",
      description:
        "Cerca negli archivi di notizie, contenuti editoriali e blog.",
    },
  },
  header: {
    scan: "SCANSIONE",
    history: "CRONOLOGIA",
    pricing: "PREZZI",
    account: "ACCOUNT",
    logout: "ESCI",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Tutti i diritti riservati. Verifica dell'Identità di Precisione.",
    privacy: "Informativa sulla Privacy",
    terms: "Termini di Servizio",
    docs: "Documentazione",
    support: "Supporto",
  },
  common: {
    loading: "Caricamento...",
    error: "Errore",
    cancel: "Annulla",
    back: "Indietro",
  },
  errors: {
    upload_failed: "Caricamento fallito. Riprova.",
    not_enough_tokens: "Non hai abbastanza token per eseguire questa ricerca.",
  },
  login: {
    disclaimer:
      "Hai bisogno di un account per usare questa app. Non inviamo spam né condividiamo la tua email. Ti consigliamo di accedere con Apple per mantenere la tua privacy.",
  },
  results: {
    input_source: "SORGENTE INPUT",
    match_thumbnail: "Miniatura della corrispondenza",
    extraction_id: "ID ESTRAZIONE",
    scan_analysis: "Analisi scansione",
    scan_description:
      "Ricerca biometrica inversa completata. Trovate %{count} corrispondenze potenziali nei registri pubblici e negli indici sociali.",
    col_identity_map: "MAPPA IDENTITÀ",
    col_verification_path: "PERCORSO VERIFICA",
    col_bio_match_score: "PUNTEGGIO BIO",
    col_action: "AZIONE",
    export_pdf: "Esporta PDF",
    exporting: "Generazione...",
    verified: "VERIFICATO",
    details: "DETTAGLI",
    details_tooltip: "Esegui confronto facciale preciso",
    details_loading: "Confronto...",
    copied: "Copiato!",
    copy_url: "Copia URL",
    displaying: "Visualizzazione di %{count} su %{total} rilevamenti",
  },
};

export default it;
